<p-checkbox v-model="model" :binary="true"></p-checkbox>